import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const index = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/views/HomePage.vue"),
      redirect: { name: "index" },
      meta: { auth: true },
      children: [
        {
          path: "index",
          name: "index",
          component: () => import("@/views/project/ProjectIndex.vue"),
        },
        {
          path: ":projectId/patents",
          name: "patent-list",
          component: () => import("@/views/patent/patent-list/PatentList.vue"),
          meta: { inProject: true },
        },
        {
          path: ":projectId/report",
          name: "report",
          component: () => import("@/views/report/ReportIndex.vue"),
          meta: { inProject: true },
        },
      ],
    },
    {
      path: "/login",
      name: "login",
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import("@/views/LoginPage.vue"),
    },
    {
      path: "/warning",
      name: "warning",
      component: () => import("@/layouts/WarningLayout.vue"),
      redirect: { name: "WarningIndex" },
      meta: { auth: true, inProject: true, projectId: "195995061321728" },
      children: [
        {
          path: "index",
          name: "WarningIndex",
          component: () => import("@/views/warning/WarningIndex.vue"),
        },
        {
          path: "technology",
          name: "TechWarning",
          component: () => import("@/views/warning/TechWarning.vue"),
        },
        {
          path: "competitor",
          name: "CompetitorWarning",
          component: () => import("@/views/warning/CompetitorWarning.vue"),
        },
      ],
    },
    {
      path: "/monitor",
      name: "monitor",
      component: () => import("@/layouts/MonitorLayout.vue"),
      redirect: { name: "MonitorIndex" },
      meta: { auth: true, inProject: true, projectId: "195995061321728", showNavHeader: false },
      children: [
        {
          path: "index",
          name: "MonitorIndex",
          component: () => import("@/views/report/ReportIndex.vue"),
        },
      ],
    },
    {
      path: "/error",
      name: "error",
      component: () => import("@/views/ErrorPage.vue"),
    },
  ],
});

export default index;


